import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { PulseLoader } from 'react-spinners';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { TermsOfUsePDF } from 'src/modules/Auth/TermsOfUse/TermsOfUsePDF';
import { TermsOfUseService } from 'src/share/services/termsOfUse';
import { IReduxState } from 'src/reduxTypes';
import { IAuthState } from 'src/modules/Auth/store/types';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import './termsOfUse.css';
import { RoutesModules } from 'src/modules/Routing/types';

export interface ITermsOfUseProps {
    auth: IAuthState;
}

export interface ITermsOfUseState {
    file: File | null;
    loading: boolean;
    showConfirmation: boolean;
}

export class UploadTermsOfUse extends React.Component<ITermsOfUseProps, ITermsOfUseState> {
    public fileInput;
    constructor(props: ITermsOfUseProps) {
        super(props);
        this.state = {
            file: null,
            loading: false,
            showConfirmation: false
        }
    }

    public readFile(file: File): Promise<any> {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (result) => this.onLoadFile(result, resolve)
        });
    }

    public onLoadFile(result: any, resolve: any) {
        const base64 = result.target && result.target.result || '';
        resolve(base64);
    }

    public uploadFile = async () => {
        try {
            this.setState({ loading: true });
            const { file } = this.state;
            if (file) {
                const base64 = await this.readFile(file);
                const status = await TermsOfUseService.saveFile(base64);
                if (status) {
                    toastr.success('Terms of use', 'The file has been uploaded correctly');
                }
                else {
                    this.setState({ file: null });
                    toastr.error('Error', 'There was a problem uploading the file');
                }
            }
        } catch {
            toastr.error('Error', 'There was a problem uploading the file');
        }
        this.setState({ loading: false, showConfirmation: false });
    }

    public fileHandler = (event) => {
        try {
            this.setState({ loading: true });
            event.preventDefault();
            if (event && event.target && event.target.files) {
                this.setState({ file: event.target.files[0] });
            } else {
                event.value = '';
            }
        } catch {
            toastr.error('Error', 'There was a problem loading the file');
        }
        this.setState({ loading: false });
    }

    public modalToggle = () => {
        this.setState({ showConfirmation: !this.state.showConfirmation })
    }

    public render() {
        const { file, loading, showConfirmation } = this.state;
        return (
            <div className="terms-of-use-upload-file">
                <div className={`terms-of-use-content white-background`}>
                    <Row>
                        <Col className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                            <h3 className="title">Upload terms of use</h3>
                            <div className="buttons-container">
                                <input className="input-select" id="upload-files-input" type="file" onChange={this.fileHandler} accept=".pdf" ref={reference => this.fileInput = reference} />
                                <label htmlFor="upload-files-input" className="label-test btn btn-input-file">Select File</label>
                            </div>
                        </Col>
                    </Row>
                    {file &&
                        <Row>
                            <Col className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                                <div className="terms-of-use-pdf-container">
                                    <TermsOfUsePDF file={file} />
                                </div>
                                <div className="buttons-container">
                                    <Button className="btn btn-blue float-right" onClick={() => this.modalToggle()} disabled={loading}>Upload</Button>
                                </div>
                            </Col>
                        </Row>}
                </div>
                <ConfirmationModal
                    isOpen={showConfirmation}
                    toggle={() => {
                        this.modalToggle();
                    }}
                    title={loading ? 'Terms of use' : 'Are you sure that you want to upload this terms of use?'}
                    description={loading ? 'Uploading file...' : 'Submitting this, all the users of GMCNgine are going to be notified once they login into the application. They will have 15 days from now to accept it'}
                    onContinue={() => this.uploadFile()}
                    loading={loading}
                    showButtons={!loading}
                />
                <div className="help-loader-sidebar">
                    <PulseLoader
                        size={20}
                        color={"#393939"}
                        loading={loading}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState) => ({
    auth: state.auth
});

export default SidebarContainer(RoutesModules.ADMIN)(connect(mapStateToProps, null)(UploadTermsOfUse));



// WEBPACK FOOTER //
// ./src/modules/UserSettings/TermsOfUse/UploadTermsOfUse.tsx